var _rect, _rect2, _rect3, _circle, _circle2, _text, _pattern, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 640,
    viewBox: "0 0 1920 640",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 220,
    width: 200,
    height: 160,
    fill: "#e0e0e0",
    stroke: "#a0a0a0",
    strokeWidth: 2,
    rx: 5,
    ry: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 260,
    width: 120,
    height: 80,
    fill: "#f5f5f5",
    stroke: "#a0a0a0",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 300,
    r: 15,
    fill: "#d0d0d0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 300,
    r: 15,
    fill: "#d0d0d0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 520,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fill: "#333"
  }, "\n    \u56FE\u7247\u52A0\u8F7D\u5931\u8D25\n  ")), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#grid)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadFail);
export default __webpack_public_path__ + "static/media/loadFail.694f34387061862dde52dde1d6af846c.svg";
export { ForwardRef as ReactComponent };